import { ActivityHistoryProfile } from "PFCore/services/activity";
import { Profile } from "PFTypes";

import { HistoryEntryDataPlaceholder } from "./history_entry_data_placeholder";
import { HistoryEntryProfile } from "./history_entry_profile";
import { HistoryEntryRow } from "./history_entry_row";

export type HistoryEventSubjectProps = {
  profile: Profile | ActivityHistoryProfile | null | undefined;
  badge?: string;
  isLoading?: boolean;
  event?: string;
};

export const HistoryEntrySubject = ({ profile, badge, isLoading, event }: HistoryEventSubjectProps) => (
  <HistoryEntryRow badge={badge}>
    {!isLoading && profile && <HistoryEntryProfile profile={profile} event={event} />}
    {isLoading && <HistoryEntryDataPlaceholder height="40px" />}
  </HistoryEntryRow>
);
